import classNames from 'classnames';
import {Provider} from 'mobx-react';
import React, {useState} from 'react';

import type {DiscoveryUnit} from '@udemy/discovery-api';
import {FunnelLogContextProvider} from '@udemy/funnel-tracking';
import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {DiscoveryUnitsContainerStore, SkillsHubUnit} from '@udemy/react-discovery-units';
import {useUDData} from '@udemy/ud-data';

import styles from './courses-to-get-you-started.module.less';

interface CoursesToGetYouStartedProps {
    coursesToGetYouStartedUnit?: DiscoveryUnit | null;
    redirectTopicUrl?: string;
}
export const CoursesToGetYouStarted: React.FC<CoursesToGetYouStartedProps> = ({
    coursesToGetYouStartedUnit,
    redirectTopicUrl = '',
}) => {
    const udData = useUDData();
    const {interpolate} = useI18n();

    const [discoveryUnitsStore] = useState(() => {
        if (!coursesToGetYouStartedUnit?.items?.length || !udData) return null;
        return new DiscoveryUnitsContainerStore(
            {
                pageType: 'topic',
                units: [coursesToGetYouStartedUnit],
            },
            udData,
        );
    });

    return (
        <>
            {coursesToGetYouStartedUnit?.items?.length && discoveryUnitsStore && (
                <FunnelLogContextProvider pageType="topic">
                    <Provider discoveryUnitsStore={discoveryUnitsStore}>
                        <div
                            className={classNames(
                                styles['courses-to-get-you-starter-container'],
                                'ud-container',
                            )}
                        >
                            <h2 className="ud-heading-xl">
                                {coursesToGetYouStartedUnit.title ?? ''}
                            </h2>
                            <div className={classNames(styles['custom-subtitle'], 'ud-text-md')}>
                                <LocalizedHtml
                                    html={interpolate(
                                        `Explore courses from experienced, real-world experts. <a class="browseAllCoursesTopicLink">Browse all courses.</a>`,
                                        true,
                                    )}
                                    interpolate={{
                                        browseAllCoursesTopicLink: (
                                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                                            <a
                                                href={redirectTopicUrl}
                                                className=" ud-btn-ghost ud-heading-md"
                                                aria-label="Browse all courses"
                                            />
                                        ),
                                    }}
                                />
                            </div>

                            <SkillsHubUnit
                                unit={coursesToGetYouStartedUnit}
                                showTitle={false}
                                gridCols={4}
                                renderExperimentalCourseCards={false}
                            />
                        </div>
                    </Provider>
                </FunnelLogContextProvider>
            )}
        </>
    );
};
